module.exports = __webpack_public_path__ + "img/logo_white.228ab293.png";